var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.12473 0.555548C3.32594 -0.223515 3.8803 -0.0604116 4.20715 0.301692C6.21838 2.60219 7.39004 5.13738 7.88285 7.45626C8.13552 8.96943 8.10872 11.3406 6.54814 12.3935C5.72881 12.9996 3.52817 12.883 2.57631 9.24615C1.85151 6.43603 2.30186 3.60571 3.12473 0.555548Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0045 6.9534C13.9246 6.47214 13.5457 6.036 12.9561 6.58343C10.6181 8.70812 8.71238 10.8485 7.80713 13.6059C6.6472 17.1818 8.43746 18.4668 9.45423 18.3984C10.0488 18.384 10.5854 18.1764 11.0604 17.8546C11.0206 17.5755 11 17.2901 11 17C11 14.7618 12.2255 12.8098 14.0421 11.7785C14.2502 10.2869 14.2604 8.66086 14.0045 6.9534Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.986699 11.315C0.579512 11.0463 0.00203818 11.0275 0.00244009 11.832C-0.0297883 14.9912 0.243462 17.8439 1.64936 20.3826C3.48223 23.6649 5.64185 23.2264 6.28317 22.4344C7.53009 21.0239 6.96185 18.7216 6.33796 17.32C5.27977 15.1987 3.51025 13.038 0.986699 11.315Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 24C20.866 24 24 20.866 24 17C24 13.134 20.866 10 17 10C13.134 10 10 13.134 10 17C10 20.866 13.134 24 17 24ZM17 23C20.3137 23 23 20.3137 23 17C23 13.6863 20.3137 11 17 11C13.6863 11 11 13.6863 11 17C11 20.3137 13.6863 23 17 23Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16H21V18H13V16Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13H18V21H16V13Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSeed);
export default __webpack_public_path__ + "static/media/AddSeed.4a459c00554ed95a38c3b47dd49ecf4f.svg";
export { ForwardRef as ReactComponent };